<!--成品检验报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationCode']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="organizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-range-picker
          slot="startAndEndDate"
          v-model="currentCreateTimeObj"
          @change="changePriceRangeDate"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiExportFinishedProductInspectionReport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetFinishedProductInspectionReport, apiExportFinishedProductInspectionReport } from '@/api/report/finished-product-verification.js'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Finished-product-inspection', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      currentCreateTimeObj: [],
      apiExportFinishedProductInspectionReport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetFinishedProductInspectionReport, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        startAndEndDate: undefined,
        startDate: undefined,
        endDate: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '工厂', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '起止日期', decorator: ['startAndEndDate'], type: 'startAndEndDate' }
      ],
      // 表格字段
      columns: [
        { title: '日期', dataIndex: 'createDate', align: 'center', width: 150, ellipsis: true },
        { title: '工厂', dataIndex: 'organizationName', align: 'center', width: 200, ellipsis: true },
        { title: '订单数', dataIndex: 'planQuantity', align: 'center', width: 150, ellipsis: true },
        { title: '检验数', dataIndex: 'checkNum', align: 'center', width: 150, ellipsis: true },
        { title: '一次合格数', dataIndex: 'firstSum', align: 'center', width: 150, ellipsis: true },
        { title: '检验覆盖率', dataIndex: 'checkRate', align: 'center', width: 150, ellipsis: true },
        { title: '一次检验合格率', dataIndex: 'onceQualifiedRate', align: 'center', width: 200, ellipsis: true }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'organizationCode',
        {
          currentCreateTimeObj: ['startDate', 'endDate']
        },
        false
      )
    } else {
      this.queryParams.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00')
      this.queryParams.endDate = moment().format('YYYY-MM-DD 23:59:59')
      this.currentCreateTimeObj = [moment().subtract(30, 'days'), moment()]
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 选择时间
    changePriceRangeDate (dateArr, dateStrArr) {
      if (dateStrArr?.length > 0 && dateStrArr[0]) {
        this.queryParams.startDate = dateStrArr[0] + ' 00:00:00'
        this.queryParams.endDate = dateStrArr[1] + ' 23:59:59'
      } else {
        this.queryParams.startDate = undefined
        this.queryParams.endDate = undefined
      }
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        startAndEndDate: undefined,
        startDate: undefined,
        endDate: undefined
      }
      this.currentCreateTimeObj = [];
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
